import CollapsibleCard from 'components/CollapsibleCard';
import { createPortal } from 'react-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { SideDrawer } from 'components/SideDrawer';

import './styles.scss';
import { SettingControl } from 'components/SettingControl';

export const PageFilterCard = ({
  className,
  children,
  collapsible = true,
  overrideIsDesktop,
}) => {
  // const isTablet = window.innerWidth <= 1440 && window.innerWidth > 1024;
  const isDesktop = overrideIsDesktop ?? window.innerWidth > 1180;

  if (isDesktop) {
    return (
      <>
        {createPortal(
          <CollapsibleCard
            className={`page-filter-card ${className}`}
            disabled={!collapsible}
            // defaultCollapsed={isTablet}
          >
            {/* <PerfectScrollbar> */}
            <CollapsibleCard.Content>
              <PerfectScrollbar>{children}</PerfectScrollbar>
            </CollapsibleCard.Content>
            {/* </PerfectScrollbar> */}

            {collapsible && <CollapsibleCard.Header />}
          </CollapsibleCard>,
          document.body
        )}
      </>
    );
  }

  return (
    <div className="mobile-filter">
      <SettingControl />
      <SideDrawer>
        <PerfectScrollbar>{children}</PerfectScrollbar>
      </SideDrawer>
    </div>
  );
};
